import config from '../configs';


function login (cb, $http, email, password) {
  var req = {
      'email': email,
      'password': password,
  }
  var endpoint = config.API; 
  $http.post(`${endpoint}/api-token-auth/`,req).then(function(res){ 
      setTimeout(() => cb(res.data), 100);
  },function(res){ 
    setTimeout(() => cb({'status': 'error', 'message': res}), 100);
  });        
}

function register (cb, $http,loginInfo) {
  var req = {
    'Email': loginInfo.email,
    'Password': loginInfo.password,
    'Address': loginInfo.address,
    'PhoneNumber': loginInfo.phone,
    'FullName': loginInfo.fullname
  }
  var endpoint = config.API; 
  $http.put(`${endpoint}/api/register/`,req).then(function(res){ 
      setTimeout(() => cb(res.data), 100);
  },function(res){ 
    setTimeout(() => cb({'status': 'error', 'message': res}), 100);
  });
}

function forgotPass (cb, $http,email) {
  var req = {
    'Email': email
  }
  var endpoint = config.API; 
  $http.post(`${endpoint}/api/forgot-pwd/`,req).then(function(res){ 
      setTimeout(() => cb(res.data), 100);
  },function(res){ 
    setTimeout(() => cb({'status': 'error', 'message': res}), 100);
  });
}

function getAllUsers(cb, $http, token){
  const req = {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "accept": "application/json",
    }
  };
  var endpoint = config.API; 
  $http.get(`${endpoint}/api/users/`,req).then(function(res){ 
      setTimeout(() => cb(res.data), 100);
  },function(res){ 
    setTimeout(() => cb({'status': 'error', 'message': res}), 100);
  });
}

export default{
  login,
  register,
  forgotPass,
  getAllUsers
}